function combinePaths(path1, path2) {
  if (path1.indexOf('/') === (path1.length - 1)) path1 = path1.substring(0, path1.length - 1);
  if (path2.indexOf('/') === 0) path2 = path2.substring(1, path2.length);

  return `${path1}/${path2}`;
}

export default {
  combinePaths
};



// WEBPACK FOOTER //
// ./src/utils/urlUtils.js